var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.visibleFlags),function(flag,i){return _c('v-tooltip',{key:i,attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"mr-2",attrs:{"small":_vm.small,"x-small":_vm.xSmall}},on),[_vm._v(" fa-"+_vm._s(flag.icon)+" ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(flag.name[_vm.locale]))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }